import eventBus from 'widgets/toolbox/eventBus';

/**
 * @description Service worker events
 * @class
 * @name ServiceWorkerEvents
 */
class ServiceWorkerEvents {
    /**
     * @description Init service worker events that will be used to communicate between tabs
     */
    init() {
        eventBus.on('broadcast.send', (message) => {
            this.sendMessageToSW(message);
        });

        navigator.serviceWorker?.addEventListener('message', event => {
            eventBus.emit('broadcast.message', event.data);
        });

        eventBus.emit('broadcast.inited');
    }

    /**
     * @description Send message to service worker
     * @param message - message to send
     * @param message.type - message type
     */
    sendMessageToSW(message) {
        navigator.serviceWorker?.ready?.then((registration) => {
            registration.active?.postMessage(message);
        });
    }
}

export default new ServiceWorkerEvents();
